import { FORM_FIELD_ID_PREFIX } from "../constants";
import { FileUploadData, FormControlType, FormStep, StepsState } from "../model/global"
import { v4 as uuidv4 } from 'uuid';
import { CustomFormFieldState } from "./FormControls/CustomFormField/CustomFormField";


/** Gets a form control by ID from an array of controls for a step */
export const getFormStepField = (fieldname: string, steps: FormControlType[]): FormControlType | undefined => {
	if (!Array.isArray(steps)) return undefined;
	return steps.find(step => step.id === fieldname);
}

/** Extracts a form control from the JSON data by ID and determines its initial state */
export const getFormControlInitialState = (fieldId: string, steps: FormControlType[]): CustomFormFieldState | undefined => {
	if (!Array.isArray(steps)) return undefined;
	const control = steps.find(step => step.id === fieldId);
	if (!control) return undefined;
	const invalid = (control.value === '' || control.value === undefined) && control.required === true
	return {
		name: control.name as string,
		value: control.value,
		originalField: control,
		required: !!control.required,
		valid: !invalid,
		invalidReason: '',
	}
}

/** Return a specific summary field from one of the step summaries */
export const getFormSummaryField = (
	summary: StepsState['formSummary'],
	stepTemplate: FormStep['stepTemplate'],
	controlName: FormControlType['name']
): CustomFormFieldState | undefined => {
	if (!controlName) return undefined;
	const item = summary.steps[stepTemplate][controlName] ? summary.steps[stepTemplate][controlName] : undefined;
	return item;
}

export const getPrefixedFieldId = (id: string | undefined): string => {
	if (!id) return FORM_FIELD_ID_PREFIX + uuidv4();
	const newId = id.replace(' ', '-');
	return `${FORM_FIELD_ID_PREFIX}_${newId}`;
}

export const getFileslotId = (index: number): string => {
	const fileId = 'file' + index.toString();
	return `${FORM_FIELD_ID_PREFIX}_${fileId}`;
}

/**
 * Convert bytes to a human readable string
 * @link https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
 * @param bytes
 * @param decimals
 * @returns
 */
export const formatBytes = (bytes: number, decimals: number = 2): string => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}


export const checkFileValidity = (theFile: File, uploads: CustomFormFieldState[], fileUploadData: FileUploadData): string => {
	const allowedContentTypes = fileUploadData.allowedContentTypes || ['image/jpeg', 'image/webp', 'image/png'];
	const maxFileSize = fileUploadData.maxFileSize || (1024 * 1024 * 4) // 4MB

	let addError = '';

	// check to make sure file is unique - use might add same one twice
	if (!fileIsUnique(uploads, theFile)) {
		// console.log('Already added this file')
		// setFileAddError(step.stepData.fieldTranslations.uniqueFileAlert || 'Error: File must be unique')
		// return;
		addError = ('Error: File must be unique')
	}

	else if (fileIsInvalidType(allowedContentTypes || [], theFile)) {
		// const typeError = step.stepData.fieldTranslations.invalidFileType || 'Error: Invalid file type';
		const typeError = 'Error: Invalid file type';
		// setFileAddError(`${typeError}: ${theFile.type}`)
		// return;
		if (theFile.type) {
			addError = (`${typeError}: ${theFile.type}`)
		} else {
			addError = (`${typeError}`)
		}
	}

	else if (filesizeExceedsLimit(Number(maxFileSize), theFile)) {
		// const sizeError = step.stepData.fieldTranslations.invalidFileSize || 'Error: Invalid file size';
		const sizeError = 'Error: Invalid file size';
		// setFileAddError(`${sizeError}`)
		// return;
		addError = (`${sizeError}`)
	}
	return addError;
}
// export const fileIsUnique = (uploadsList: File[], theFile: File): boolean => {
// 	const existsAlready = uploadsList.some(f => {
// 		return (
// 			f.type === theFile.type && f.name === theFile.name && f.size === theFile.size && f.lastModified === theFile.lastModified
// 		)
// 	});
// 	return !existsAlready
// }
export const fileIsUnique = (uploadsList: CustomFormFieldState[], theFile: File): boolean => {
	const existsAlready = uploadsList.some(f => {
		if (!f.fileDetails) return false;
		return (
			f.fileDetails.fileType === theFile.type && f.fileDetails.fileName === theFile.name && f.fileDetails.fileSize === theFile.size && f.fileDetails.lastModified === theFile.lastModified
		)
	});
	return !existsAlready
}

export const fileIsInvalidType = (allowedContentType: string[], theFile: File): boolean => {

	const formatAllowed = allowedContentType.find(t => {
		return t.toLowerCase() === theFile.type.toLowerCase()
	})
	return formatAllowed === undefined;
}

export const filesizeExceedsLimit = (maxFileSizeBytes: number, theFile: File): boolean => {
	return theFile.size > maxFileSizeBytes;
}
